<template>
  <div class="workspace__container__view">
    <div class="workspace__container__view__header">
      <div class="workspace__container__view__header__actions">
        <button @click="createOrEdit()">{{ $t("workspace.client_category.create_category") }}</button>
      </div>
      <div class="workspace__container__view__header__filter">
        <div class="container__inputs">
          <div class="settings-input">
            <input type="text" v-model="filterModel.code" :placeholder="`${$t('workspace.client_category.filter_for')} ${$t('workspace.client_category.code')}`">
          </div>
          <div class="settings-input">
            <input type="text" v-model="filterModel.name" :placeholder="`${$t('workspace.client_category.filter_for')} ${$t('workspace.client_category.name')}`">
          </div>
        </div>
        <button class="filter-clear-button" :disabled="filterModel.name == '' && filterModel.code == ''" @click="filterModel.name = ''; filterModel.code = ''"><i class="material-icons" style="font-size: 20px">filter_alt_off</i></button>
      </div>
    </div>

    <div class="table-scroll">
      <table class="workspace__container__view__table with-padding">
        <thead>
          <tr>
            <th>{{$t('workspace.client_category.priority')}}</th>
            <th>{{$t('workspace.client_category.code')}}</th>
            <th>{{$t('workspace.client_category.name')}}</th>
            <th class="actions">{{$t('workspace.client_category.actions')}}</th>
          </tr>
        </thead>
        <tbody>
          <template v-if="listCategories(filterModel).length > 0">
            <tr v-for="item in listCategories(filterModel)" :key="item.code">
              <td>{{item.priority}}</td>
              <td v-html="highlightText(item.code, filterModel.code)"></td>
              <td v-html="highlightText(item.name, filterModel.name)"></td>
              <td class="actions">
                <i class="material-icons" @click="createOrEdit(item)">edit</i>
                <i class="material-icons" @click="deleteItem(item)">delete</i>
              </td>
            </tr>
          </template>
          <tr v-if="listCategories(filterModel).length == 0 && !isFilterActive">
            <td colspan="4">{{$t('workspace.not_have_loaded')}} <strong>{{ $t("left_menu.commercial_config.client_category") }}</strong>. {{$t('workspace.please')}} <strong style="text-decoration: underline; cursor: pointer" @click="createOrEdit()">{{ $t("workspace.client_category.create_category") }}</strong></td>
          </tr>
          <tr v-if="listCategories(filterModel).length == 0 && isFilterActive">
            <td colspan="4" v-html="$t('workspace.none_results_with_filters')"></td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
import { ref } from '@vue/reactivity'
import { useStore } from 'vuex';
import { computed, onMounted } from '@vue/runtime-core';
import highlightText from '@/plugins/Mixin/highlightText.js';

export default {
  mixins: [highlightText],
  setup() {
    const store = useStore();
    const listCategories = computed(() => filterModel => store.getters.clientCategory_categories(filterModel));
    const isFilterActive = computed(() => filterModel.value.code != '' || filterModel.value.name != '');
    const filterModel = ref({
      code: '',
      name: ''
    });

    onMounted(async () => {
      store.dispatch('loading_setActive', true);
      await store.dispatch('clientCategory_getAll');
      store.dispatch('loading_setActive', false);
    });

    async function createOrEdit(item) {
      await store.dispatch('modal_setActive', {active: 'COMMERCIAL-CONFIG_CLIENT-CATEGORY_CREATE-EDIT', props: item});
    }
    
    async function deleteItem(item) {
      await store.dispatch('modal_setActive', {active: 'COMMON_DELETE', props: item, actionDelete: 'clientCategory_delete'});
    }

    return {
      listCategories,
      filterModel,
      isFilterActive,
      createOrEdit,
      deleteItem
    }
  }
}
</script>
<style lang="scss" scoped>
  @import '@/styles/_variables.scss';

  .filter-clear-button {
    background: $lighter-gray-color;
    color: #fff;

    &:disabled {
      opacity: .5;
    }
  }
</style>